import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class ErrorHandlerService extends ErrorHandler {
	constructor(private errorHandler?: ErrorHandler) {
		super();
	}

	public handleError(error: any): void {
		if (this.errorHandler) {
			this.errorHandler.handleError(error);
		} else {
			ErrorHandler.prototype.handleError.call(this, error);
		}
	}
}
